import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";
const driverBasePath = `${API_URLS.DRIVERS}`;

async function fetchDriverList(clientId) {
  try {
    const queryString = new URLSearchParams();
    queryString.append("ClientId", clientId);

    const response = await api.get(`${driverBasePath}/Drivers?${queryString}`);

    console.log("DriverList", response);

    let treated = errorHandling.handleResponse(
      response,
      "driverService.fetchDriverList"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "driverService.fetchDriverList");
    return null;
  }
}

async function createDriver(payload) {
  try {
    const response = await api.post(`${driverBasePath}/Drivers`, payload);

    console.log("CreateDriver", response);

    let treated = errorHandling.handleResponse(
      response,
      "driverService.createDriver"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "driverService.createDriver");
    return null;
  }
}

async function updateDriver(payload) {
  try {
    const response = await api.put(
      `${driverBasePath}/Drivers/${payload.driverId}`,
      payload
    );

    console.log("UpdateDriver", response);

    let treated = errorHandling.handleResponse(
      response,
      "driverService.updateDriver"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "driverService.updateDriver");
    return null;
  }
}

async function deleteDriver(driverId) {
  try {
    const response = await api.delete(`${driverBasePath}/Drivers/${driverId}`);

    console.log("DeleteDriver", response);

    let treated = errorHandling.handleResponse(
      response,
      "driverService.deleteDriver"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "driverService.deleteDriver");
    return null;
  }
}

async function fetchLinkedVehiclesToDriver(driverId) {
  try {
    const response = await api.get(
      `${driverBasePath}/Drivers/${driverId}/vehicles`
    );

    console.log("LinkedVehiclesToDriver", response);

    let treated = errorHandling.handleResponse(
      response,
      "driverService.fetchLinkedVehiclesToDriver"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "driverService.fetchLinkedVehiclesToDriver");
    return null;
  }
}

async function linkVehicleToDriver(payload) {
  try {
    const response = await api.patch(
      `${driverBasePath}/Drivers/${payload.driverId}/link-vehicles`,
      payload
    );

    console.log("LinkVehicleToDriver", response);

    let treated = errorHandling.handleResponse(
      response,
      "driverService.linkVehicleToDriver"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "driverService.linkVehicleToDriver");
    return null;
  }
}

async function unlinkVehicleToDriver(payload) {
  try {
    const response = await api.patch(
      `${driverBasePath}/Drivers/${payload.driverId}/unlink-vehicles`,
      payload
    );

    console.log("UnlinkVehicleToDriver", response);

    let treated = errorHandling.handleResponse(
      response,
      "driverService.unlinkVehicleToDriver"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "driverService.unlinkVehicleToDriver");
    return null;
  }
}

async function exportDriver() {
  try {
    const response = await api.get(
      `${driverBasePath}/Drivers/download`,
      {
        responseType: 'blob'
      }
    );

    console.log("exportDriver", response);

    let treated = errorHandling.handleResponse(
      response,
      "driverService.exportDriver"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "driverService.exportDriver");
    return null;
  }
}

async function importDriver(file) {
  const formData = new FormData();
  formData.append("DriverFile", file, file.name);

  try {
    const response = await api.patch(
      `${driverBasePath}/Drivers/upload`,
      formData
    );

    let treated = errorHandling.handleResponse(
      response,
      "driverService.importDriver"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "driverService.importDriver");
    return null;
  }
}

async function uploads(scheduleQueueId, eventTypeId, completed, active) {
  try {
    const queryString = new URLSearchParams();
    if (scheduleQueueId !== null && scheduleQueueId !== undefined) {
      queryString.append("ScheduleQueueId", scheduleQueueId);
    }
    if (eventTypeId !== null && eventTypeId !== undefined) {
      queryString.append("EventTypeId", eventTypeId);
    }
    if (completed !== null && completed !== undefined) {
      queryString.append("Completed", completed);
    }
    if (active !== null && active !== undefined) {
      queryString.append("Active", active);
    }
    
    const response = await api.get(
      `${driverBasePath}/Drivers/uploads${queryString.toString() ? '?' + queryString.toString() : ''}`
    );

    console.log("uploads", response);

    let treated = errorHandling.handleResponse(
      response,
      "driverService.uploads"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "driverService.uploads");
    return null;
  }
}

export const driverService = {
  fetchDriverList,
  createDriver,
  updateDriver,
  deleteDriver,
  fetchlinkedVehicleToDriver: fetchLinkedVehiclesToDriver,
  linkVehicleToDriver,
  unlinkVehicleToDriver,
  exportDriver,
  importDriver,
  uploads
};
